// This site does not use TempurLove features.
// Export exists to satisfy Reactivated build requirements.
export { Template } from "tsi-common-react/src/templates/TempurLoveGridTemplate";
